import { render, staticRenderFns } from "./RptVentas.vue?vue&type=template&id=5ab5b6b0&"
import script from "./RptVentas.vue?vue&type=script&lang=js&"
export * from "./RptVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports